import { render, staticRenderFns } from "./DataUpload.vue?vue&type=template&id=ff96b688&"
import script from "./DataUpload.vue?vue&type=script&lang=js&"
export * from "./DataUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports